module.exports = __webpack_public_path__ + "static/apple_store_badge-8943920e765aa5c94511a95fc3df9971.svg";